import { UUID } from 'crypto';
import Decimal from 'decimal.js';
import { Stowage } from 'src/types/ViewModel/Stowage/Stowage';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';

export const findLoadingStowageItemsForCargo = (stowagePlan: StowagePlan, tank: Tank, cargoGuid: UUID): Stowage[] => {
    return stowagePlan.stowageItems.filter(
        (s) => s.tankId === tank.tankId && s.cargoOperation.operationType === 'Loading' && s.cargoOperation.cargoGuid === cargoGuid
    );
};

export const findUnloadingStowageItemsForCargo = (stowagePlan: StowagePlan, tank: Tank, cargoGuid: UUID): Stowage[] => {
    return stowagePlan.stowageItems.filter(
        (s) => s.tankId === tank.tankId && s.cargoOperation.operationType === 'Unloading' && s.cargoOperation.cargoGuid === cargoGuid
    );
};

export const findTransferredToStowageItemsForCargo = (stowagePlan: StowagePlan, tank: Tank, cargoGuid: UUID): Stowage[] => {
    return stowagePlan.stowageItems.filter(
        (s) => s.tankId === tank.tankId && s.cargoOperation.operationType === 'Transfer' && s.cargoOperation.cargoGuid === cargoGuid && s.weight.gt(0)
    );
};

export const findTransferredFromStowageItemsForCargo = (stowagePlan: StowagePlan, tank: Tank, cargoGuid: UUID): Stowage[] => {
    return stowagePlan.stowageItems.filter(
        (s) => s.tankId === tank.tankId && s.cargoOperation.operationType === 'Transfer' && s.cargoOperation.cargoGuid === cargoGuid && s.weight.lt(0)
    );
};

export const findUnloadingStowageItemsForCargoOperation = (stowagePlan: StowagePlan, tank: Tank, cargoOperationGuid: UUID): Stowage[] => {
    return stowagePlan.stowageItems.filter(
        (s) =>
            s.tankId === tank.tankId && s.cargoOperation.operationType === 'Unloading' && s.cargoOperation.cargoOperationGuid === cargoOperationGuid
    );
};

export const getStowageItemsWeight = (items: Stowage[]): Decimal => items.reduce((acc, item) => acc.plus(item.weight), new Decimal(0));
